import { contextMenuManager } from './ContextMenuManager.js';

/**
 * Context menu for edge (connection) actions
 */
export class EdgeContextMenu {
    constructor() {
        this.menu = null;
        this.isVisible = false;
        this.onDelete = null;
        this.createElement();
    }

    /**
     * Create the context menu DOM element
     */
    createElement() {
        this.menu = document.createElement('div');
        this.menu.id = 'edge-context-menu';
        this.menu.className = 'fixed bg-slate-800 border border-slate-700 rounded-lg shadow-2xl py-2 z-[1002] hidden min-w-[180px]';

        // Create delete menu item
        const deleteItem = this.createMenuItem(
            'Supprimer la connexion',
            '<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/></svg>',
            () => this.handleDelete(),
            'text-red-400 hover:bg-red-600/20'
        );

        this.menu.appendChild(deleteItem);

        document.body.appendChild(this.menu);

        // Close menu when clicking outside
        document.addEventListener('click', (e) => {
            if (this.isVisible && !this.menu.contains(e.target)) {
                this.hide();
            }
        });

        console.log('✅ Edge context menu created');
    }

    /**
     * Create a menu item
     */
    createMenuItem(label, icon, onClick, extraClasses = '') {
        const item = document.createElement('div');
        item.className = `px-4 py-2 hover:bg-slate-700 cursor-pointer flex items-center gap-3 text-sm text-slate-200 transition-colors ${extraClasses}`;

        item.innerHTML = `
            ${icon}
            <span>${label}</span>
        `;

        item.addEventListener('click', (e) => {
            e.stopPropagation();
            onClick();
            this.hide();
        });

        return item;
    }

    /**
     * Show the context menu at specific position
     */
    show(x, y, onDelete) {
        // Notify the manager that this menu is now active (will close other menus)
        contextMenuManager.setActiveMenu(this);

        this.onDelete = onDelete;

        // Position the menu
        this.menu.style.left = `${x}px`;
        this.menu.style.top = `${y}px`;

        // Make sure menu stays within viewport
        const rect = this.menu.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        if (rect.right > viewportWidth) {
            this.menu.style.left = `${viewportWidth - rect.width - 10}px`;
        }

        if (rect.bottom > viewportHeight) {
            this.menu.style.top = `${viewportHeight - rect.height - 10}px`;
        }

        this.menu.classList.remove('hidden');
        this.isVisible = true;
        console.log('📋 Edge context menu shown');
    }

    /**
     * Hide the context menu
     */
    hide() {
        this.menu.classList.add('hidden');
        this.isVisible = false;
        this.onDelete = null;

        // Clear from manager if this was the active menu
        if (contextMenuManager.activeMenu === this) {
            contextMenuManager.clearActiveMenu();
        }

        console.log('📋 Edge context menu hidden');
    }

    /**
     * Handle delete action
     */
    handleDelete() {
        if (this.onDelete) {
            this.onDelete();
        }
    }

    /**
     * Remove the menu from DOM
     */
    dispose() {
        if (this.menu && this.menu.parentNode) {
            this.menu.parentNode.removeChild(this.menu);
            this.menu = null;
            console.log('✅ Edge context menu disposed');
        }
    }
}
